import http, {download} from "../../../utils/HttpUtils";

//客户账单接口服务
class CustomerBillService {
    //分页查询客户汇总信息
    static async findPage(data) {
        const apiUrl = "/bill/customer/findSummaryPage";
        return await http.post(apiUrl, data);
    }

    //分页查询客户账单汇总信息
    static async loadBillList(data) {
        const apiUrl = "/bill/customer/findBillPage";
        return await http.post(apiUrl, data);
    }

    //客户账单平账
    static async BillFlat(data) {
        const apiUrl = "/bill/customer/balance";
        return await http.post(apiUrl, data);
    }

    //账单平账记导出
    static async export(res) {
        const apiUrl = "/bill/customer/export";
        await download(apiUrl, res)
    }

    // 汇总列表导出
    static async export(res) {
        const apiUrl = "/bill/customer/export";
        await download(apiUrl, res)
    }

    //客户账单平帐记录
    static async loadBalanceList(data) {
        const apiUrl = "/bill/customer/balance/findRecord";
        return await http.post(apiUrl, data);
    }

    //客户账单平帐详情
    static async loadBalanceDetail(data = null) {
        const apiUrl = "/bill/customer/balance/" + data;
        return await http.get(apiUrl, data);
    }
}

export default CustomerBillService;
